import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AdminUsersState, User, UsersQuery, UsersQueryParameter } from "./models/AdminUsersModels";
import AdminUsersApi from "./api/adminUsersApi";

export const getUsers = createAsyncThunk(
  "adminUsers/getUsers",
  async (query: UsersQuery) => {
    return AdminUsersApi.getUsers(query);
  }
);

export const changeUser = createAsyncThunk(
  "adminUsers/changeUser",
  async ({ id, model }: any) => {
    return AdminUsersApi.changeUser(id, model);
  }
);

export const changeUserStatus = createAsyncThunk(
  "adminUsers/changeUserDisabled",
  async ({ id, isDisabled }: any) => {
    return AdminUsersApi.changeUserStatus(id, isDisabled);
  }
);

export const deleteUser = createAsyncThunk(
  "adminUsers/deleteUser",
  async (id: string) => {
    return AdminUsersApi.deleteUser(id);
  }
);

const initialState: AdminUsersState = {
  query: {
    search: undefined,
    sortBy: UsersQueryParameter.createdDate,
    sortDesc: true,
    pageNo: 1,
    pageSize: 20
  },
  users: undefined,
  user: undefined,
  loading: false,
  success: undefined,
  error: undefined
};

const adminUsersSlice = createSlice({
  name: "adminUsers",
  initialState: initialState,
  reducers: {
    changeQuery: (state, action) => {
      state.query = action.payload;
    },
    selectUser: (state, action) => {
      state.user = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, { payload }) => {
        state.users = payload;
        state.loading = false;
      })
      .addCase(getUsers.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(changeUserStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeUserStatus.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(changeUserStatus.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUser.fulfilled, (state, { payload }) => {
        state.loading = false;
      })
      .addCase(deleteUser.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });
  }
});

export const {
  changeQuery,
  selectUser,
  setSuccess
} = adminUsersSlice.actions;

export default adminUsersSlice.reducer;